<app-wizard-modal [vertical]="true"
                  (stepChange)="onStepChange($event)"
                  (cancel)="onWizardCancel()"
                  (submit)="onWizardSubmit()">
    <app-wizard-title>{{ 'admin.tools.form.title' | translate }}</app-wizard-title>
    <app-wizard-step [canContinue]="toolDetailsValid">
        <ng-template #title>{{ 'admin.tools.form.sections.details' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-details-form
                [tool]="tool"
                [showValidations]="step.nextTriggered"
                (changedLine)="onLineChange($event)">
            </app-tool-details-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.form.sections.specialIdentifications' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-special-identifiers-form
                [toolFormModel]="tool"
                (identifiersChanged)="tool.setData($event)">
            </app-tool-special-identifiers-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="toolLifecycleValid">
        <ng-template #title>{{ 'admin.tools.form.sections.lifecycle' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-lifecycle-form [tool]="tool"
                                     [showValidations]="step.nextTriggered"></app-tool-lifecycle-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.form.sections.parts' | translate }}</ng-template>
        <ng-template #content>
            <app-tool-part-numbers-form
                *ngIf="tool"
                [availableParts]="availableParts"
                [(selectedPartNumbers)]="tool.partNumbers">
            </app-tool-part-numbers-form>
        </ng-template>
    </app-wizard-step>

    <app-wizard-step *ngIf="isSPI">
        <ng-template #title>{{ 'admin.tools.form.sections.insertionCycles' | translate }}</ng-template>
        <ng-template #content>
            <div class="row">
                <div class="col s12">
                    <app-alert *ngIf="!selectedMainLine.isSPI"
                               [responsive]="true"
                               type="warning"
                               message="{{'admin.tools.create-modal.pick-list.insertionCycles.alerts'| translate}}"></app-alert>
                </div>
            </div>
            <app-tool-insertion-cycles-form
                *ngIf="tool"
                [availableInsertionCycles]="availableInsertionCycles"
                [(selectedInsertionCycles)]="tool.insertionCycles"
                [isSPI]="selectedMainLine.isSPI">
            </app-tool-insertion-cycles-form>
        </ng-template>
    </app-wizard-step>

    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.form.sections.mainEquipments' | translate }}</ng-template>
        <ng-template #content>
            <app-tool-main-equipment-form
                *ngIf="tool"
                [availableMainEquipments]="availableMainEquipments"
                [(selectedMainEquipments)]="tool.mainEquipment">
            </app-tool-main-equipment-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.form.sections.secondaryEquipments' | translate }}</ng-template>
        <ng-template #content>
            <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
            <app-tool-secondary-equipment-form
                *ngIf="tool && !isLoading"
                [availableSecondaryEquipments]="availableSecondaryEquipments"
                [(selectedSecondaryEquipments)]="tool.secondaryEquipment">
            </app-tool-secondary-equipment-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]="true" [saveDisabled]="!toolsetCodesForm?.allFormsValid">
        <ng-template #title>{{ 'admin.tools.form.sections.codes' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-toolset-codes-form
                #toolsetCodesForm
                [tool]="tool"
                [toolId]="duplicateMode ? null : tool?.id"
                [isLoading]="isLoading"
                [showValidations]="step.nextTriggered">
            </app-toolset-codes-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="toolDetailsValid"
                     [isAfterSubmit]="true">
        <ng-template #title>{{ 'admin.tools.form.sections.engrave' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-engrave [toolsToScan]="toolDatamatrix"
                              [isScanListenerActive]="step.isActive"></app-tool-engrave>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [isAfterSubmit]="true">
        <ng-template #title>{{ 'admin.tools.form.sections.backups' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-backups
                [selectedTool]="tool"
                [toolBackups]="toolBackups">
            </app-tool-backups>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [isAfterSubmit]="true">
        <ng-template #title>{{'admin.tools.form.sections.maintenancePlan' | translate}}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-maintenance-plan [tool]="tool"></app-tool-maintenance-plan>
        </ng-template>
    </app-wizard-step>

</app-wizard-modal>
